<template>
  <div class="app-wrapper"
       :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <top-small-nav></top-small-nav>
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import TopSmallNav from './components/TopSmallNav'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    TopSmallNav,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue